import { BaseDevice, jingtaiV2LightAndSpeedRange } from '@/profiles/base_device'
import { CustomLayout } from '../../base_device'
import list_icon from '@/assets/img/device/mars75/list_icon.png'
import { DevicePid, EffectIndex, KK } from '@/define/define'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { polar75VKCodes } from '../keycode/vkeycode'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_JTV2 } from '../../light/light_effect_list'
export class Mars75Pro extends BaseDevice {
  name: string = 'Mars75_PRO'
  icon: string = list_icon
  width: number = 628
  vkcodes = polar75VKCodes
  square = getDeviceKeySquare(DevicePid.IYXPolar75)
  y_number = 10
  magneticAxis: boolean = true
  fnDisableKeys: KK[] = [0x1, 0x2, 0x3, 0x4, 0x5, 0x6, 0x7, 0x8, 0x9, 0xa, 0xb, 0xc, 0x10b, 0x10c, 0x302, 0x403, 0x501, 0x50a, 0x40d, 0x50d, 0x50c, 0x50e]
  inoperableKeys: KK[] = [0x50b]
  customLayout: CustomLayout = {
    0x01: this.createSquare(8),
    0x05: this.createSquare(6),
    0x09: this.createSquare(6),
    0x0d: this.createSquare(6),

    0x100: this.createSquare(2, this.y_number),
    0x101: this.createSquare(2, this.y_number),
    0x102: this.createSquare(2, this.y_number),
    0x103: this.createSquare(2, this.y_number),
    0x104: this.createSquare(2, this.y_number),
    0x105: this.createSquare(2, this.y_number),
    0x106: this.createSquare(2, this.y_number),
    0x107: this.createSquare(2, this.y_number),
    0x108: this.createSquare(2, this.y_number),
    0x109: this.createSquare(2, this.y_number),
    0x10a: this.createSquare(2, this.y_number),
    0x10b: this.createSquare(2, this.y_number),
    0x10c: this.createSquare(2, this.y_number),
    0x10d: this.createSquare(2, this.y_number, 55),
    0x10e: this.createSquare(2, this.y_number),

    0x200: this.createSquare(2, 2, 47),
    0x20d: this.createSquare(2, 2, 45),
    0x300: this.createSquare(2, 2, 68),
    0x30d: this.createSquare(2, 2, 63),
    0x0400: this.createSquare(2, 2, 78),
    0x040c: this.createSquare(2, 2, 54),
    0x500: this.createSquare(2, 2, 52),
    0x501: this.createSquare(2, 2, 52),
    0x502: this.createSquare(2, 2, 52),
    0x506: this.createSquare(2, 2, 194),
    0x50a: this.createSquare(2, 2, 52),
    0x50b: this.createSquare(2, 2, 52),
    0x50c: this.createSquare(19, 2),
  }

  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_JTV2

  speedAllowValues: number[] = jingtaiV2LightAndSpeedRange()
  lightAllowValues: number[] = jingtaiV2LightAndSpeedRange()

  rate: number[] = [0.25, 0.5, 1, 2, 4, 8]
  sleepTimeValues: number[] = [60, 2 * 60, 3 * 60, 5 * 60, 15 * 60, 30 * 60, 1 * 60 * 60, 2 * 60 * 60, 0]
}
